(() => {
  const ROOT_SELECTOR = '[data-paths-all]';

  function initPathsAll(root) {
    if (!root || root.dataset.pathsAllInitialized === 'true') return;

    root.dataset.pathsAllInitialized = 'true';

    const filterContainer = root.querySelector('[data-paths-all-filters]');
    const filterButtons = Array.from(
      root.querySelectorAll('[data-path-filter]')
    );

    const products = Array.from(
      root.querySelectorAll('[data-paths-all-product]')
    );

    const emptyState = root.querySelector('[data-paths-all-empty]');
    const resetButton = root.querySelector('[data-paths-all-reset]');
    const countElement = root.querySelector('[data-paths-all-count]');
    const pagination = root.querySelector('[data-paths-all-pagination]');

    if (!filterContainer || !filterButtons.length || !products.length) {
      if (emptyState) {
        emptyState.hidden = true;
      }

      return;
    }

    const totalCount =
      Number.parseInt(countElement?.dataset.totalCount || '', 10) ||
      products.length;

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function productMatchesFilter(product, filter) {
      if (filter === 'all') return true;

      const category = normalize(product.dataset.pathCategory);

      if (!category) return false;

      return (
        category === filter ||
        category.includes(filter) ||
        filter.includes(category)
      );
    }

    function updateCount(visibleCount, activeFilter) {
      if (!countElement) return;

      const count = activeFilter === 'all' ? totalCount : visibleCount;
      const noun = count === 1 ? 'Path' : 'Paths';

      countElement.textContent = `${count} ${noun}`;
    }

    function updateButtons(activeFilter) {
      filterButtons.forEach((button) => {
        const buttonFilter = normalize(button.dataset.pathFilter);
        const isActive = buttonFilter === activeFilter;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }

    function applyFilter(filterValue, options = {}) {
      const { scrollToProducts = false } = options;
      const activeFilter = normalize(filterValue) || 'all';

      let visibleCount = 0;

      products.forEach((product) => {
        const shouldShow = productMatchesFilter(product, activeFilter);

        product.hidden = !shouldShow;
        product.setAttribute('aria-hidden', String(!shouldShow));

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      updateButtons(activeFilter);
      updateCount(visibleCount, activeFilter);

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }

      if (pagination) {
        pagination.hidden = activeFilter !== 'all';
      }

      root.dataset.activeFilter = activeFilter;

      if (scrollToProducts) {
        const productsSection = root.querySelector('.paths-all__products');

        productsSection?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.pathFilter || 'all';

        applyFilter(filter);
      });
    });

    resetButton?.addEventListener('click', () => {
      applyFilter('all');

      filterContainer.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    });

    applyFilter('all');
  }

  function initAllPathsSections(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) {
      initPathsAll(scope);
    }

    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initPathsAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllPathsSections();
    });
  } else {
    initAllPathsSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllPathsSections(event.target);
  });
})();